// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"480":"710cd81e","604":"63282f50","739":"b64df224","851":"f99c8ebc","905":"d739580f","972":"c7efac85"}[chunkId] + ".css";
};